import React, { useState } from "react";
import BodyClassName from "react-body-classname";
import { SurveyQuestionCheckboxItem } from "survey-react";
import SelectedItems from "./selectedItems";
import Filters from "./filters";
import SearchBox from "./searchBox";
import "./productSelection.scss";
export default function ProductSelection(props) {
  const [filters, setFilters] = useState([]);
  const [isFiltersDialog, setIsFiltersDialog] = useState(false);
  const [keyword, setKeyword] = useState("");

  function getItems(question) {
    const renderedItems = [];

    for (let i = 0; i < question.visibleChoices.length; i++) {
      const item = question.visibleChoices[i];
      if (filters.length !== 0 && !filters.includes(item.collection)) continue;
      const trimmedKeyword = keyword.trim().toLocaleLowerCase();
      if (
        trimmedKeyword.length !== 0 &&
        !item.text.toLocaleLowerCase().includes(trimmedKeyword)
      )
        continue;
      //console.log(item);
      const key = "item" + i;
      const renderedItem = (
        <SurveyQuestionCheckboxItem
          key={key}
          question={question}
          cssClasses={question.cssClasses}
          isDisplayMode={false}
          item={item}
          textStyle={null}
          isFirst={i === 0}
          index={i}
        />
      );
      renderedItems.push(renderedItem);
    }
    return renderedItems;
  }

  // get the "none" radiogroup question if it exists in the page
  /*
  const noneQuestion = props.question.parent.questionsValue.find(element => element instanceof QuestionRadiogroupModel);
  
  const radioItem = noneQuestion ?
  ReactElementFactory.Instance.createElement("survey-radiogroup-item",  {question: noneQuestion, item: noneQuestion.visibleChoices[0], cssClasses: noneQuestion.cssClasses})
  : null;
*/
  const radioItem = null;

  const filtersDialogClass = isFiltersDialog
    ? "product-selection--filters-open"
    : "";

  return (
    <div className={`product-selection ${filtersDialogClass}`}>
      {isFiltersDialog && <BodyClassName className="body-filters-open" />}
      <SelectedItems question={props.question} />
      <div className="product-selection__flex">
        <div className="product-selection__left">
          <Filters
            setFilters={setFilters}
            filters={filters}
            setIsFiltersDialog={setIsFiltersDialog}
          />
        </div>
        <div className="product-selection__right">
          <SearchBox setKeyword={setKeyword} />
          {radioItem}
          <fieldset className="sv_q_checkbox-left product-selection__list">
            <legend className={"sv-hidden"}>Product selection</legend>
            {getItems(props.question)}
          </fieldset>
        </div>
      </div>
    </div>
  );
}
